module.exports = __webpack_public_path__ + "static/media/8OLA1.a7264e4a.jpg";